import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'fc_cookie_consent';

const CookieBanner = () => {
 const [visible, setVisible] = useState(false);

 useEffect(() => {
  try {
   const accepted = localStorage.getItem(STORAGE_KEY) === '1';
   if (!accepted) {
    // small delay so banner doesn't flash before page paints
    const t = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(t);
   }
  } catch (_) {
   setVisible(true);
  }
 }, []);

 const handleAccept = () => {
  try { localStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
  setVisible(false);
 };

 if (!visible) return null;

 return (
  <div
   className="fixed inset-x-0 bottom-0 z-[70] px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none"
   data-testid="cookie-banner"
   role="dialog"
   aria-label="Уведомление об использовании cookies"
  >
   <div
    className="pointer-events-auto mx-auto max-w-[1100px] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 sm:gap-8 px-6 sm:px-8 py-5 sm:py-6 border border-[#B38F6F]/25"
    style={{
     background: 'rgba(10, 10, 10, 0.85)',
     backdropFilter: 'blur(16px)',
     WebkitBackdropFilter: 'blur(16px)',
    }}
   >
    <p className="text-[13px] sm:text-[13px] text-[#F2F1ED]/85 font-light leading-relaxed">
     Сайт использует cookies.{' '}
     <Link
      to="/privacy"
      className="underline underline-offset-[3px] decoration-[#B38F6F]/50 hover:decoration-[#B38F6F] hover:text-[#B38F6F] transition-colors duration-300"
      data-testid="cookie-banner-policy-link"
     >
      Политика конфиденциальности
     </Link>
    </p>
    <button
     type="button"
     onClick={handleAccept}
     className="self-start sm:self-auto inline-flex items-center gap-2 px-7 py-2.5 border border-[#B38F6F] text-[#B38F6F] hover:bg-[#B38F6F] hover:text-[#F2F1ED] text-[10px] uppercase tracking-[0.22em] font-light transition-all duration-[400ms] whitespace-nowrap"
     data-testid="cookie-banner-accept-btn"
    >
     Принять
    </button>
   </div>
  </div>
 );
};

export default CookieBanner;
